<template xmlns:template="http://www.w3.org/1999/html">
  <vx-card
      title="Alergeny globalne"
      title-color="primary"
  >
    <vs-input class="w-1/2 mb-4" label-placeholder="Wyszukaj alergen"
              v-model="search" placeholder="Wyszukaj alergen"/>

    <vs-button @click="togglePopup()" class="mb-2">Dodaj nowy Alergen</vs-button>
    <vs-popup class="holamundo" class-content="flex items-center justify-center" title="Dodaj nowy Alergen" :active.sync="popupActive">
      <vs-input placeholder="Nazwa" v-model="newGlobalAllergen.name" class="w-1/2"/>
      <vs-input placeholder="Nazwa EN" v-model="newGlobalAllergen.name_en" class="w-1/2"/>
      <vs-button @click="storeGlobalAllergen" class="ml-2">Dodaj</vs-button>
    </vs-popup>

    <vs-table id="global-allergens-container" :data="globalAllergens">
      <template #thead>
        <vs-th>Nazwa</vs-th>
        <vs-th>Nazwa EN</vs-th>
        <vs-th>Globalne</vs-th>
        <vs-th>Edycja</vs-th>
      </template>

      <!-- global allergen edit popup -->
      <vs-popup class="holamundo" class-content="flex items-center justify-center" title="Edytować Alergen" :active.sync="editPopupActive">
        <vs-input placeholder="Nazwa" v-model="selectedGlobalAllergen.name" class="w-1/2"/>
        <vs-input placeholder="Nazwa EN" v-model="selectedGlobalAllergen.name_en" class="w-1/2"/>
        <vs-button @click="updateGlobalAllergen" class="ml-2">Edytować</vs-button>
      </vs-popup>

      <template>
        <vs-tr v-for="globalAllergen in globalAllergens" :key="globalAllergen.id">
          <vs-td>
            {{ globalAllergen.name }}
          </vs-td>
          <vs-td>
            {{ globalAllergen.name_en }}
          </vs-td>
          <vs-td :data="globalAllergen.is_global" class="text-center">
            <vs-switch disabled="true" v-model="globalAllergen.is_global"/>
          </vs-td>
          <vs-td :data="globalAllergen.id" class="text-center">
            <div v-if="activeUserInfo.id === globalAllergen.created_by || activeUserInfo.userRole === 'admin'" class="flex">
              <div class="fonticon-wrap mx-1">
                <vx-tooltip text="Usuń">
                  <a @click=deleteGlobalAllergen(globalAllergen.id) class="feather icon-delete cursor-pointer"></a>
                </vx-tooltip>
              </div>
              <div class="fonticon-wrap mx-1">
                <vx-tooltip text="Edytuj">
                  <a @click="toggleEditPopup(globalAllergen)" class="feather icon-edit cursor-pointer"></a>
                </vx-tooltip>
              </div>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div class="flex gap-8">
      <vs-pagination class="mt-4" :total="globalAllergensCount" :max="perpage" v-model="globalAllergensPage" goto></vs-pagination>
      <div class="flex mt-2 w-3/12 items-center">
        Wyniki na stronie:&nbsp;
        <vs-select
            class="w-16"
            label=""
            v-model="perpage"
        >
          <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item,index in perpageOptions" />
        </vs-select>
      </div>

    </div>

  </vx-card>
</template>

<script>
import Vue from "vue";

export default {
  name: "globalAllergens",
  data() {
    return {
      selectedGlobalAllergen: {
        name: '',
        name_en: '',
      },
      globalAllergens: [],
      newGlobalAllergen: {
        name: null,
        name_en: null,
      },
      page: {
        buttons: [
          {
            name: 'Dodaj nowy Alergen',
            onClick: this.togglePopup,
            external: false
          },
        ]
      },
      popupActive: false,
      editPopupActive: false,
      globalAllergensPage: 1,
      globalAllergensCount: 0,
      search: '',
      isLoading: false,
      perpage: 10,
      perpageOptions:[
        {text:'10',value:10},
        {text:'20',value:20},
        {text:'50',value:50},
        {text:'100',value:100},
      ],
    }
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    }
  },
  watch: {
    globalAllergensPage: function () {
      this.fetchData();
    },
    perpage: function (newPerpage, oldPerpage) {
      if(newPerpage > oldPerpage) {
        this.globalAllergensPage = 1;
      }
      this.fetchData();
    },
    search: function (a, b) {
      if (!this.isLoading) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.globalAllergensPagePage = 1;
          this.fetchGlobalAllergensFiltered(a);
          this.isLoading = true;
        }, 2000);
      }
    }
  },
  methods: {
    toggleEditPopup(globalAllergen) {
      this.selectedGlobalAllergen = JSON.parse(JSON.stringify(globalAllergen));
      this.editPopupActive = !this.editPopupActive;
    },
    togglePopup() {
      this.popupActive = !this.popupActive;
    },
    openLoadingInDiv() {
      this.$vs.loading({
        container: '#global-allergens-container',
        scale: 0.6
      });
    },
    closeLoadingInDiv() {
      this.$vs.loading.close('#global-allergens-container > .con-vs-loading')
    },
    updateGlobalAllergen() {
      const url = process.env.VUE_APP_API_ENDPOINT + '/v1/global-allergens/' + this.selectedGlobalAllergen.id;
      this.$http.put(url,{
        global_allergen: this.selectedGlobalAllergen,
      }).then(response => {

        this.editPopupActive = false;

        if(response.data.errors !== undefined && response.data.errors.length > 0) {
          console.log(response.data.errors[0].title);
          this.$vs.notify({title:'Error.',text:response.data.errors[0].title, color:'warning'})
        }
        else {
          this.$vs.notify({title:'Sukces.',text:'Alergen zaktualizowano', color:'primary'});

          const idx = this.globalAllergens.findIndex(glAln => glAln.id === response.data.data.global_allergen.id);
          this.$set(this.globalAllergens,idx,response.data.data.global_allergen);
        }
      });
    },
    storeGlobalAllergen() {
      // store new category
      const url = process.env.VUE_APP_API_ENDPOINT + '/v1/global-allergens'
      this.$http.post(url,{
        global_allergen: {
          name: this.newGlobalAllergen.name,
          name_en: this.newGlobalAllergen.name_en
        },
      }).then( (response) => {
        this.popupActive = false;
        //console.log(response.data.errors);
        if(response.data.errors !== undefined && response.data.errors.length > 0) {
          console.log(response.data.errors[0].title);
          this.$vs.notify({title:'Error.',text:response.data.errors[0].title, color:'warning'})
        }
        else {
          this.$vs.notify({title:'Sukces.',text:'Nowy Alergen dodano', color:'primary'});
          this.$set(this,'globalAllergens',[...this.globalAllergens,response.data.data.global_allergen]);
        }
      });
    },
    deleteGlobalAllergen(id) {
      const url = process.env.VUE_APP_API_ENDPOINT + `/v1/global-allergens/${id}`
      this.$http.delete(url)
          .then((response) => {
            if(response.data.errors !== undefined && response.data.errors.length > 0) {
              console.log(response.data.errors[0].title);
              this.$vs.notify({title:'Error.',text:response.data.errors[0].title, color:'warning'})
            }
            else {
              this.$vs.notify({title:'Sukces.',text:'Alergen usunięty', color:'primary'});
              // remove global allergen from array
              this.$set(this,'globalAllergens',this.globalAllergens.filter(globalAllergen => globalAllergen.id !== id))
            }
          });
    },
    fetchData() {
      //this.fetchGlobalAllergens();
      this.fetchGlobalAllergensFiltered();
    },
    fetchGlobalAllergensFiltered() {
      this.openLoadingInDiv();
      //const url = process.env.VUE_APP_API_ENDPOINT + '/v1/global-allergens?q=' + this.search
      this.$http.get(process.env.VUE_APP_API_ENDPOINT + '/v1/global-allergens?q=' + this.search + '&p=' + this.globalAllergensPage + '&perpage=' + this.perpage)
          .then(response => {
            this.globalAllergens = response.data.data.global_allergens;
            // this.allIngredients = response.data.data.all;
            this.globalAllergensCount = Math.ceil(response.data.data.count / this.perpage);
            this.isLoading = false;
            this.closeLoadingInDiv();
          });
    },
  },

}
</script>

<style scoped>

</style>
